import React, { ReactElement } from 'react';
import isEqual from 'lodash.isequal';
import { useUserData } from 'b2b-apps/shop/context/hooks';
import { useTranslate } from 'b2b-apps/shop/i18n/hooks';
import { EnhancedComponentProps, EnhancedComponentType, InjectedProps, WrappedComponentType } from './';

export const withContainer = (Component: WrappedComponentType): EnhancedComponentType => {
  const WithContainer = (props: EnhancedComponentProps): ReactElement => {
    const { isLoggedIn, isBlocked } = useUserData();
    const t = useTranslate();
    const alertMessage = t('This account has been blocked and purchasing has been disabled. Please contact Customer Service for more information.');

    const injectedProps: InjectedProps = {
      isLoggedIn,
      isBlocked,
      alertMessage,
    };

    return <Component {...injectedProps} { ...props} />;
  };

  return React.memo(WithContainer, (prevProps, nextProps) => isEqual(prevProps, nextProps));
};
